var _excluded = ["from", "to", "isHidden", "hasForcedFullWidth", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
var StyledBreakpointVisibilityOrg = styled.div.withConfig({
  componentId: "sc-w1dd9z-0"
})(function (_ref) {
  var $from = _ref.$from,
    $to = _ref.$to,
    $isHidden = _ref.$isHidden,
    $hasForcedFullWidth = _ref.$hasForcedFullWidth;
  if ($isHidden) {
    return css(["", "{display:none;}"], breakpoint($from, $to));
  }
  return css(["display:none;", "{display:block;}", ""], breakpoint($from, $to), $hasForcedFullWidth ? css(["width:100%;"]) : null);
});
function BreakpointVisibilityOrg(_ref2) {
  var from = _ref2.from,
    to = _ref2.to,
    isHidden = _ref2.isHidden,
    hasForcedFullWidth = _ref2.hasForcedFullWidth,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledBreakpointVisibilityOrg, _extends({
    $from: from,
    $to: to,
    $isHidden: !!isHidden,
    $hasForcedFullWidth: !!hasForcedFullWidth
  }, restProps), children);
}
export default BreakpointVisibilityOrg;